import * as ko from "knockout";
import entityBase from "entityBase";

export enum UPLOAD_STATUS {
  WAITING_TO_BE_UPLOADED = "WAITING_TO_BE_UPLOADED",
  UPLOADING = "UPLOADING",
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
  UPLOADED = "UPLOADED",
}

export class attachment extends entityBase {
  attachment_class: KnockoutObservable<string>;
  attachment_description: KnockoutObservable<string>;
  attachment_id: KnockoutObservable<number>;
  attachment_name: KnockoutObservable<string>;
  attachment_path: KnockoutObservable<string>;
  attachment_type: KnockoutObservable<string>;
  download_path: KnockoutObservable<string>;
  file_extension: KnockoutObservable<string>;
  file_size: KnockoutObservable<number>;
  file_type: KnockoutObservable<string>;
  internal_type: KnockoutObservable<string>;
  signer: KnockoutObservable<string>;
  file: any;
  uploadStatus: KnockoutObservable<UPLOAD_STATUS>;

  constructor(item: any) {
    super();
    this.attachment_class = ko.observable(item.attachment_class).extend({ maxLength: 128 });
    this.attachment_description = ko.observable(item.attachment_description || "-").extend({ maxLength: 512 });
    this.attachment_id = ko.observable(item.attachment_id);
    this.attachment_name = ko.observable(item.attachment_name).extend({ maxLength: 128 });
    this.attachment_path = ko.observable(item.attachment_path).extend({ maxLength: 512 });
    this.attachment_type = ko.observable(item.attachment_type).extend({ maxLength: 128 });
    this.download_path = ko.observable(item.download_path).extend({ maxLength: 2048 });
    this.file_extension = ko.observable(item.file_extension).extend({ maxLength: 128 });
    this.file_size = ko.observable(item.file_size);
    this.file_type = ko.observable(item.file_type).extend({ maxLength: 128 });
    this.internal_type = ko.observable(item.internal_type).extend({ maxLength: 128 });
    this.signer = ko.observable(item.signer).extend({ maxLength: 64 });
    this.file = item?.file;

    this.uploadStatus = ko.observable(UPLOAD_STATUS.WAITING_TO_BE_UPLOADED);
  }
}
